<<template>
    <div>
        <!-- <div style="border: 1px solid black" v-for="area in this.$store.getters.filteredModel('areas')">{{ area.name }}</div> -->
        <!-- <div style="border: 1px solid black" v-for="area in areas">{{ area.name }}</div> -->
        <gmap-map ref="mymap" :center="geoLocation" :zoom="20">
            <gmap-info-window v-if="pInfo.valid" :options="pInfo.options" :position="pInfo.coordinates" :opened="pInfo.opened" :content="pInfo.content" @closeclick="pInfo.opened = false"></gmap-info-window>
            <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" :content="infoContent" @closeclick="infoWinOpen=false"></gmap-info-window>
            <gmap-marker v-for="(area, i) in $store.getters.filteredModel('areas')" :position="area.coordinates | calcGeoLocation" :icon="area | calcIcon" :clickable="true" @click="toggleInfoWindow(area, i)"></gmap-marker>
        </gmap-map>
    </div>
</template>

<<script>
import { calcGeoLocation, isData } from "root/tools.js"

export default {
    props: {
		areas: Array,
		center: String,
		markers: Array,
		info: {
			type: Object,
			default () {
				return {
					options: {
						pixelOffset: {
							width: 0,
							height: -35
						}
					},
					coordinates: {
						lat: 0,
						lng: 0
					},
					opened: true,
					content: ""
				}
			}
		}
    },

    data () {
        return {
			infoContent: "",
			infoWindowPos: {
				lat: 0,
				lng: 0
			},
			infoWinOpen: false,
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: 0
				}
			}
		}
	},
	
	activated () {
		this.$refs.mymap.resizePreserveCenter()
	},

	computed: {
		geoLocation () {
			console.log("center", this.center)

			if (isData(this.center)) {
				return this.calcGeoLocation(this.center)
			} else {
				let lLocations = this.$store.getters.filteredModel('areas')
				let lLocation = Array.isArray(lLocations) & lLocations.length > 0 ? lLocations[0].coordinates : "0 0, 0 0"
				let lCalcedLoc = this.calcGeoLocation(lLocation)

				if (typeof this.$refs.mymap !== "undefined") {
					console.log("Moving to ", lCalcedLoc)
					this.$refs.mymap.panTo(lCalcedLoc)
				}

				return lCalcedLoc
			}
		},

		pInfo () {
			/*
				<gmap-info-window v-if="pInfo.valid"
				:options="pInfo.options"
				:position="pInfo.coordinates"
				:opened="pInfo.opened"
				:content="pInfo.content"
				@closeclick="pInfo.opened = false">
				</gmap-info-window>
			*/

			return {
				valid: true,
				options: this.info.options,
				coordinates: this.info.coordinates,
				opened: this.info.opened,
				content: this.info.content
			}
		}
    },

	methods: {
		calcGeoLocation: calcGeoLocation,

		goTo (aID) {
			console.log(aID)
		},

		toggleInfoWindow (marker, idx) {
			let Template = ''
			Template += '<table>'
			Template += '	<tr>'
			Template += '		<th>'
			Template += '			Name: '
			Template += '		</th>'
			Template += '		<td>'
			Template += '			' + marker.name
			Template += '		</td>'
			Template += '	</tr>'
			Template += '	<tr>'
			Template += '		<th>'
			Template += '			Kategorie: '
			Template += '		</th>'
			Template += '		<td>'
			Template += '			' + marker.short_name
			Template += '		</td>'
			Template += '	</tr>'
			Template += '	<tr>'
			Template += '		<th>'
			Template += '			Preis (€): '
			Template += '		</th>'
			Template += '		<td>'
			Template += '			' + marker.real_price
			Template += '		</td>'
			Template += '	</tr>'
			Template += '	<tr>'
			Template += '		<th>'
			Template += '			Buchungen: '
			Template += '		</th>'
			Template += '		<td>'
			Template += '			' + marker.summary
			Template += '		</td>'
			Template += '	</tr>'
			Template += '	<tr>'
			Template += '		<th>'
			Template += '			Verstorbene: '
			Template += '		</th>'
			Template += '		<td>'
			Template += '			' + marker.deceased_count
			Template += '		</td>'
			Template += '	</tr>'
			Template += '</table>'
			Template += '<a href="/areas/'+ marker.id +'">Bearbeiten ...</a>'

			this.infoWindowPos = this.calcGeoLocation(marker.coordinates);
			this.infoContent = Template

			//check if its the same marker that was selected if yes toggle
			if (this.currentMidx == idx) {
				this.infoWinOpen = !this.infoWinOpen;
			}

			//if different marker set infowindow to open and reset current marker index
			else {
				this.infoWinOpen = true;
				this.currentMidx = idx;
			}
		}
	},

	filters: {
		calcGeoLocation: calcGeoLocation,

		getTitle (aArea) {
			return aArea.name
		},
		
		calcIcon (aArea) {
			// var SuffixIndex = ["[Vergeben]", "[Teilbelegt]", "[Frei]", "[Keine Gräber]"].indexOf(aArea.status)
			/* return {
				"url": "/img/icons/black_blue.svg",
				"size":  new google.maps.Size(25, 25),
				"scaledSize": new google.maps.Size(25, 25)
			} */
			//return "https://dev.w3.org/SVG/tools/svgweb/samples/svg-files/android.svg"
			switch (aArea.short_name) {
				case "BEE":
					return {
						"url": "/img/icon_blau.png",
						"scaledSize": new google.maps.Size(20, 20),
						"labelOrigin": { "x": 0, "y": 0 }
					}

				case "BAG":
					return {
						"url": "/img/icon_weis.png",
						"scaledSize": new google.maps.Size(20, 20),
						"labelOrigin": { "x": 0, "y": 0 }
					}

				case "BBG":
					return {
						"url": "/img/icon_weis.png",
						"scaledSize": new google.maps.Size(20, 20),
						"labelOrigin": { "x": 0, "y": 0 }
					}

				case "BEG":
					return {
						"url": "/img/icon_weis.png",
						"scaledSize": new google.maps.Size(20, 20),
						"labelOrigin": { "x": 0, "y": 0 }
					}

				case "BFG":
					return {
						"url": "/img/icon_weis.png",
						"scaledSize": new google.maps.Size(20, 20),
						"labelOrigin": { "x": 0, "y": 0 }
					}

				default:
					return {
						"url": "/img/icon_gruen.png",
						"scaledSize": new google.maps.Size(20, 20),
						"labelOrigin": { "x": 0, "y": 0 }
					}
			}
		},

	}
}
</script>



// WEBPACK FOOTER //
// map-marker.vue?d5717914